<template>
  <transition-group
    name="toast-slide"
    tag="div"
    class="wc-toast-modern-root"
    :class="{ 'wc-toast-modern-root--anchored': top }"
  >
    <div v-for="toast in ToastService.modernToasts" :key="toast.id" class="wc-toast-modern-item">
      <component
        v-bind="toast.props"
        :is="toast.component"
        :data-id="toast.id"
        v-bind:close="toast.close"
        v-bind:dismiss="toast.dismiss"
        v-bind:startTimeout="toast.startTimeout"
        v-on="toast.actions"
      />
    </div>
  </transition-group>
</template>

<script>
import ToastService from '../../services/ToastService';

const TOAST_ANCHOR_SELECTOR = '#desktop-header-v2, .wc-mobile-subpage-header';

export default {
  name: 'WCToastRootModern',
  data() {
    return {
      ToastService,
      top: null,
    };
  },
  computed: {
    toastCount() {
      return ToastService.modernToasts.value.length;
    },
  },
  watch: {
    toastCount(count) {
      if (count > 0) {
        this.$nextTick(this.reposition);
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.reposition);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.reposition);
  },
  methods: {
    reposition() {
      const anchors = Array.from(document.querySelectorAll(TOAST_ANCHOR_SELECTOR));
      const bottom = Math.max(0, ...anchors.map(anchor => anchor.getBoundingClientRect().bottom));
      this.top = bottom ? `${bottom}px` : null;
      if (this.top) {
        this.$el?.style?.setProperty('--wc-toast-top', this.top);
      } else {
        this.$el?.style?.removeProperty('--wc-toast-top');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-toast-modern-root {
  position: fixed;
  top: rem(15px);
  left: rem(15px);
  right: rem(15px);
  z-index: map-get($zindex, 'toasts');
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.wc-toast-modern-root--anchored {
  top: calc(var(--wc-toast-top, #{rem(15px)}) + 12px);
}

.wc-toast-modern-item {
  width: 100%;
}
</style>
